import { Box, Button, DialogActions, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultModal from '../../components/Modals/DefaultModal';
import { QuickPayment } from '../../models/quickPayment';
import { TALENT } from '../../router/constants';

interface ModalProps {
  open: boolean;
  setOpen: (e: boolean) => void;
  duplicates: QuickPayment[];
}

export default function DuplicateModal(props: ModalProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <DefaultModal open={props.open} handleClose={() => props.setOpen(false)}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Duplicated Entry
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          You have multiple talents with the same name, please check the
          talent&apos;s ID number and select the correct one for each payment.
        </Box>
      </Box>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 3 }}>
        <Button onClick={() => props.setOpen(false)}>Later</Button>
        <Button onClick={() => navigate(TALENT)}>See talents</Button>
      </DialogActions>
    </DefaultModal>
  );
}
